export default [
  {
    title: 'Budget do Líder',
    icon: 'AwardIcon',
    action: 'read',
    resource: 'BudgetLider',
    children: [
      {
        title: 'Budgets do Líder',
        route: 'budget-lider',
        icon: 'CircleIcon',
        action: 'read',
        resource: 'BudgetLider',
      },
      {
        title: 'Dashboard',
        route: 'budget-lider-dashboard',
        icon: 'BarChart2Icon',
        action: 'read',
        resource: 'BudgetLider',
      },
    ],
  },
];
